import { render } from "./modelDetails.vue?vue&type=template&id=4b976f7e&scoped=true"
import script from "./modelDetails.vue?vue&type=script&lang=js"
export * from "./modelDetails.vue?vue&type=script&lang=js"

import "./modelDetails.vue?vue&type=style&index=0&id=4b976f7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b976f7e"]])

export default __exports__